<div class="main-page-content">

  <div class="main-page-content-block" *ngIf="!currentItem && loading">
    Loading...
  </div>
  <div class="main-page-content-block text-lg" *ngIf="currentItem">
    <div class="row">
      <div class="col ">
        <h1 class="content-heading-font">
          #{{ currentItem.SiteId }} {{currentItem.SiteName }}
        </h1>

      </div>
    </div>
    <div class="row">
      <div class="col mb-2">
        {{GetStatusText(currentItem)}}
      </div>
    </div>
    <div class="row">
      <div class="col-12  col-xl-6  ">
        <p class="card-text">

          <span>Requests </span>: <span class="font-weight-bold">{{currentItem.RequestsExecuting_App}} ({{(currentItem.RequestExecutingTime_App || 0/1000.0) | number: '1.2-2' }} s) / {{currentItem.RequestsInQueue_App}} ({{ (currentItem.RequestWaitTime_App ||0)/1000.0 | number: '1.2-2' }} s) </span><br />

          <span>Requests per Min </span>: <span class="font-weight-bold">{{currentItem.RequestsMin_App || currentItem.RequestsMin_Http}}</span><br />
          <span>Requests In Queue</span>: <span class="font-weight-bold">{{currentItem.RequestsInQueue_App || currentItem.RequestsInQueue_Http}} ({{ (currentItem.RequestWaitTime_App || 0)/1000.0 | number: '1.2-2' }} s)</span><br />
          <span>Requests Executing</span>: <span class="font-weight-bold">{{currentItem.RequestsExecuting_App}}  ({{ (currentItem.RequestExecutingTime_App || 0)/1000.0 | number: '1.2-2' }} s) </span><br />
          <span>Current Connections</span>: <span class="font-weight-bold">{{currentItem.CurrentConnections_Http}} </span><br />
          <span>Bytes Received / Sent</span>: <span class="font-weight-bold">{{formatByteSize(currentItem.BytesReceivedSec)}} / {{formatByteSize(currentItem.BytesSentSec)}}</span><br />
          <span>CPU / RAM</span>: <span class="font-weight-bold">{{currentItem.PercentProcessorTime}}% / {{formatByteSizeMB(currentItem.WorkingMemoryMB )}} </span><br />
          <span> Worker Process</span>:
          <span class="font-weight-bold">{{currentItem.ProcessIDs}}</span>
          <span class="font-weight-bold text-info" *ngIf="currentItem.IsIdle">(Idle)</span>
          <br />



        </p>
      </div>

      <div class="col-12  col-xl-6  ">
        <div *ngIf="currentItem.DomainNames">
          <span>Domain Names</span>: <span class="font-weight-bold">{{currentItem.DomainNames}}</span><br />
        </div>
        <div *ngIf="currentItem.ApplicationPool">
          <span>Application Pool</span>: <span class="font-weight-bold">{{currentItem.ApplicationPool}}</span><br />
        </div>
        <div *ngIf="currentItem.AppDomain">
          <span>App Domain</span>: <span class="font-weight-bold">{{currentItem.AppDomain}}</span><br />
        </div>
        <div *ngIf="currentItem.MachineName">
          <span>Machine Name</span>: <span class="font-weight-bold">{{currentItem.MachineName}}</span><br />
        </div>
        <div *ngIf="currentItem.Version">
          <span>Version</span>: <span class="font-weight-bold">{{currentItem.Version}}</span><br />
        </div>
        <div *ngIf="currentItem.BuildDate">
          <span>Build Date</span>: <span class="font-weight-bold">{{currentItem.BuildDate | date:'medium' }}</span><br />
        </div>
        <div *ngIf="currentItem.PhysicalPath">
          <span>Physical Path</span>: <span class="font-weight-bold">{{currentItem.PhysicalPath}}</span><br />
        </div>
        <div *ngIf="currentItem.FileName">
          <span>File Name</span>: <span class="font-weight-bold">{{currentItem.FileName}}</span><br />
        </div>

        <div>
          <span>Run Time</span>: <span class="font-weight-bold"> {{getRuntime(currentItem.StartTime )}} since {{currentItem.StartTime | date:'medium' }}</span><br />
        </div>
        <div>
        </div>
        <div>
        </div>
      </div>

    </div>

  </div>




  <div class="main-page-content-block-secondary" *ngIf="loadingLists">
    Loading...
  </div>

  <div class="main-page-content-block-secondary mt-3" *ngIf="webSiteRequests && webSiteRequests.length > 0">
    <h1 class="content-heading-font ms-2">Executing Requests</h1>

    <div class="row">
      <div class="col-12  ">
        <p-table #dt1
                 dataKey="ID"
                 [value]="webSiteRequests"
                 [responsive]="true"
                 [paginator]="true"
                 [rows]="25"
                 [loading]="loadingLists"
                 [showCurrentPageReport]="true"
                 currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                 [rowsPerPageOptions]="[10, 25, 50, 100, 1000]"
                 
                 [lazy]="false"
                 styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped  "
                 sortField="TimeElapsed" [sortOrder]="-1">
         
          <ng-template pTemplate="header">
            <tr>

              <th pSortableColumn="Date" class="text-center" style="width:130px;">
                Time<p-sortIcon field="Date"></p-sortIcon>
                <p-columnFilter type="date" field="Date" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="TimeElapsed" class="text-end">
                Time Elapsed (ms) <p-sortIcon field="TimeElapsed"></p-sortIcon>
                <p-columnFilter type="numeric" field="TimeElapsed" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="ClientIPAddress" class="text-center">
                IP Address
                <p-sortIcon field="ClientIPAddress"></p-sortIcon>
                <p-columnFilter type="text" field="ClientIPAddress" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="PipelineState" class="text-start">
                State
                <p-sortIcon field="PipelineState"></p-sortIcon>
                <p-columnFilter type="text" field="PipelineState" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="CurrentModule" class="text-start">
                Module
                <p-sortIcon field="CurrentModule"></p-sortIcon>
                <p-columnFilter type="text" field="CurrentModule" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="Url" class="text-start">
                Url
                <p-sortIcon field="Url"></p-sortIcon>
                <p-columnFilter type="text" field="Url" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
           
              <td class="text-center text-nowrap ">
                <span title="{{ item.Date | date: 'short' }}"> {{ getRuntime(item.Date) }}</span>
              </td>
              <td class="text-end  " [ngClass]="{'fw-bold text-danger bg-dark': item.TimeElapsed>5000}">
                {{ item.TimeElapsed /1000.0 | number: '1.2-2' }} s
              </td>
              <td class="text-center text-nowrap ">
                {{ item.ClientIPAddress }} #{{ item.ConnectionId }}
              </td>
              <td class="text-start text-nowrap ">
                {{ item.PipelineState }} ({{ item.TimeInState /1000.0 | number: '1.2-2' }} s)
              </td>
              <td class="text-start text-nowrap ">
                {{ item.CurrentModule }} ({{ item.TimeInModule /1000.0 | number: '1.2-2' }} s)
              </td>
              <td class=" text-break text-truncate " style="max-width: 10vw;">
                {{ item.Verb }} <a href="https://{{ item.HostName }}{{ item.Url }}" target="_blank"> {{ item.Url }} </a>
              </td>

            </tr>
          </ng-template>
        
       
        </p-table>



      </div>
    </div>

  </div>

  <div class="main-page-content-block mt-3" *ngIf="webUrls && webUrls.length > 0">
    <h1 class="content-heading-font ms-2">Monitored Web URLs</h1>


    <div class="row">
      <div class="col-12" style="aspect-ratio: 21/9; margin-bottom:50px;">
        <ngx-charts-line-chart [results]="webUrlsData"
                               [legend]="true"
                               [legendTitle]="''"
                               [animations]="false"
                               [xAxis]="true"
                               [xAxisLabel]="'Time'"
                               [showXAxisLabel]="false"
                               [trimXAxisTicks]="false"
                               [maxXAxisTickLength]="25"
                               [yAxis]="true"
                               [yAxisLabel]="'Response Time (ms)'"
                               [showYAxisLabel]="true"
                               [trimYAxisTicks]="false"
                               [yScaleMin]="0"
                               [timeline]="true"
                               [legendPosition]="legendPosition"
                               (select)="onChartSelect($event)">
        </ngx-charts-line-chart>
      </div>
    </div>

    <div class="row d-none">
      <div class="col-12 col-md mb-3" *ngFor="let webUrl of webUrls; let i = index">
        <div class="card text-bg-{{GetStatusColor(webUrl)}}">
          <div class="card-header fs-4 text-truncate" style="min-width: 400px;">
            <div class="float-end ">
              <button class="btn btn-sm card-header-btn " type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#WebSite' + webUrl.ID">
                <i class="fa fa-angle-double-down "></i>
              </button>
            </div>
            {{webUrl.UrlName}}
          </div>
          <div class="card-body">
            <h5 class="card-title font-weight-bold ">{{GetStatusText(webUrl)}}</h5>
            <p class="card-text">
              <span>Response Time Taken</span>: <span class="font-weight-bold">{{webUrl.ResponseTimeTaken}}ms</span><br />
              <span>HTTP Status Code</span>: <span class="font-weight-bold"> {{webUrl.ResponseHttpStatusCode }}</span><br />
              <span>Response Date</span>: <span class="font-weight-bold"> {{getRuntime(webUrl.ResponseDate )}} since {{webUrl.ResponseDate | date:'medium' }}</span><br />


            </p>
            <div class="collapse " id="WebSite{{webUrl.ID}}">
              <div *ngIf="webUrl.ResponseText">
                <span class="font-weight-bold">{{webUrl.ResponseText}}</span><br />
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</div>


